// extracted by mini-css-extract-plugin
module.exports = {"page":"reviews_page__zs0OS","content":"reviews_content__QSw2P","loading":"reviews_loading__3szd3"};